import { IPaginationDTO, IPaginationResponse } from '@/models/pagination.model';

export enum AdminsEndpoints {
  ADMINS = '/admins',
  ADMINS_LIST = '/admins/list',
}

export enum AdminRoles {
  MANAGER = 'MANAGER',
  FULL_ADMIN = 'FULL_ADMIN',
  LOWEST = 'LOWEST',
}

export enum AdminStatus {
  ACTIVE = 'active',
  DEACTIVATED = 'deactivated',
}

// ----------------- DTOs ----------------

export interface IGetAdminsListDTO extends Partial<IPaginationDTO> {
  role?: AdminRoles;
  status?: AdminStatus;
  full_name?: string;
  email?: string;
  phone_number?: string;
}

export interface ICreateAdminDTO {
  role?: AdminRoles;
  full_name?: string;
  email?: string;
  phone_number?: string;
}

export interface IUpdateAdminDTO {
  id?: string;
  role?: AdminRoles;
  status?: AdminStatus;
  full_name?: string;
  email?: string;
  phone_number?: string;
}

// ------------ Responses --------------

export interface IAdmin {
  PK: string;
  SK: string;
  status: AdminStatus;
  role?: AdminRoles;
  full_name?: string;
  email?: string;
  phone_number?: string;
}

export interface IAdminResponse {
  data: IAdmin;
}

export interface IAdminsListResponse {
  items: IAdmin[];
  cursor: IPaginationResponse;
}
